import { MaterialIcon } from 'mol-ui';
import { PDFViewer } from 'views/components';
import PropTypes from 'prop-types';
import React from 'react';
import {
    CloseIcon,
    Container,
    ViewerContainer
} from './styled';

const PDFFullScreenViewer = ({
    file,
    toggle
}) => (
    <Container>
        <CloseIcon onClick={ toggle }>
            <MaterialIcon
                color="#ffffff"
                icon="close"
                size={ 25 }
            />
        </CloseIcon>
        <ViewerContainer>
            <PDFViewer
                file={ file }
            />
        </ViewerContainer>
    </Container>
);

PDFFullScreenViewer.propTypes = {
    file: PropTypes.string,
    toggle: PropTypes.func
};

export default PDFFullScreenViewer;
